import { TipoClassificacaoCadastro } from './cadastro';
import { TipoClassificacao } from './tipo-classificacao';

/** Representa um agrupamento de tipos de classificações por cadastro */
export class TipoClassificacaoGrupoCadastro {
    cadastro: TipoClassificacaoCadastro;
    tiposClassificacoes: TipoClassificacao[];

    constructor(cadastro: TipoClassificacaoCadastro) {
        this.cadastro = cadastro;
        this.tiposClassificacoes = [];
    }
}
